import { Swiper } from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

class Slider {
	selector: HTMLElement;

	constructor( selector: HTMLElement ) {
		this.selector = selector;
		this.selector && this.init();
	}

	initCarousel( element: HTMLElement, options: any ): Swiper {
		return new Swiper( element, options );
	}

	init() {
		let swiperOptions: any = {};
		let arrayModules: any[] = [];
		let getAttributesSelector = JSON.parse( this.selector.getAttribute( 'swiper-config' ) || '{}' );
		if ( getAttributesSelector.pagination ) {
			arrayModules.push( Pagination );
			swiperOptions = {
				...swiperOptions,
				modules: arrayModules,
			};
		}
		if ( getAttributesSelector.navigation ) {
			arrayModules.push( Navigation );
			swiperOptions = {
				...swiperOptions,
				modules: arrayModules,
			};
		}
		if ( getAttributesSelector.autoPlay ) {
			arrayModules.push( Autoplay );
			swiperOptions = {
				...swiperOptions,
				modules: arrayModules,
				autoplay: {
					delay: getAttributesSelector.autoPlay.delay,
				},
			};

		}
		if ( getAttributesSelector.effect ) {
			arrayModules.push( EffectFade );
			swiperOptions = {
				...swiperOptions,
				modules: arrayModules,
				fadeEffect: { crossFade: true },
			};
		}
		swiperOptions = {
			...swiperOptions,
			...getAttributesSelector,
		};
		Swiper.use(arrayModules);
		return new Swiper( this.selector, {
			...swiperOptions
		} );
	}
}

export default Slider;
